import React, { useEffect, useState } from 'react';
import { Instagram } from 'lucide-react';

const STORAGE_KEY = 'pace_social_follow_banner_dismissed_v1';

export default function SocialFollowBanner({
  storageKey = STORAGE_KEY,
  instagramUrl = 'https://www.instagram.com/sustainabilityhub.ai?igsh=MW5xa2VtNWxidDF3NQ==',
}) {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      setDismissed(raw === '1');
    } catch (_e) {
      setDismissed(false);
    }
  }, [storageKey]);

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(storageKey, '1');
    } catch (_e) {
      // ignore (private mode / blocked storage)
    }
  };

  return (
    <div className="bg-white border border-emerald-100/70 rounded-xl px-3 py-3 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="p-2 bg-emerald-100 rounded-lg flex items-center justify-center shrink-0">
          <Instagram className="h-5 w-5 text-emerald-700" aria-hidden="true" />
        </div>

        <div className="min-w-0 flex-1">
          <div className="text-sm text-gray-900 font-semibold leading-snug">
            Follow us on social media counts as one action 🌱
          </div>
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-flex items-center text-sm font-semibold text-emerald-700 hover:text-emerald-800 underline underline-offset-2"
          >
            Follow us on Instagram
          </a>
        </div>

        <div className="flex items-center shrink-0">
          <button
            type="button"
            onClick={dismiss}
            className="h-8 w-8 grid place-items-center rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2"
            aria-label="Dismiss social follow banner"
            title="Dismiss"
          >
            <span className="text-lg leading-none">×</span>
          </button>
        </div>
      </div>
    </div>
  );
}

